import { render, staticRenderFns } from "./IEAlert.vue?vue&type=template&id=13d0634b&"
import script from "./IEAlert.vue?vue&type=script&lang=js&"
export * from "./IEAlert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports